module.exports = "<div class=\"ot-indicator\">\n  <div class=\"ot-icon\">\n    <span class=\"icon-notifications\"></span>\n    <span class=\"ot-notification badge\">{{item.notificationCount}}</span>\n  <div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/navigation/indicator.html
 ** module id = 286
 ** module chunks = 1
 **/